import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '@environments/environment';
import { IFBJobApplicationCloseReason, IFBLanguage, IFBRewardPaymentBehavior } from '@interfaces';

@Injectable({
  providedIn: 'root'
})
export class CoreDataResource {
  constructor(private http: HttpClient) {}

  private url(suffix: string): string {
    return `https://${environment.API_BASE}/v1/coredata/${suffix}`;
  }

  public getJobApplicationCloseReasons() {
    return this.http.get<{ items: IFBJobApplicationCloseReason[] }>(this.url('jobapplications/closereasons'));
  }

  public getLanguages() {
    return this.http.get<IFBLanguage[]>(this.url('languages'));
  }

  public getRewardPaymentBehaviors() {
    return this.http.get<IFBRewardPaymentBehavior[]>(this.url('reward_payment_behaviors'));
  }
}
